import { Box, Button, CircularProgress, Grid, TextField } from "@mui/material";
import { useFormik } from "formik";
import { toast } from "sonner";
import { useKeycloak } from "@react-keycloak/web";
import Loader from "../../common/Loader";
import { useCreateOrg } from "../../../../tanstackQuery/queries/superAdmin/org";
import { useQueryClient } from "@tanstack/react-query";
export interface CreateOrgSuperAdminData {
  name: string;
  type: string;
}
const CreateOrgForm = ({handleClose}) => {
  const { keycloak } = useKeycloak();
  const client = useQueryClient();

  const { mutateAsync: createOrg, isPending, isSuccess, } = useCreateOrg(
    { accessToken: keycloak?.token },
    {
      onSuccess: () => {
        client.invalidateQueries({ queryKey: ["orgtree"] });
        client.invalidateQueries({ queryKey: ["orgListSA"] });
        handleClose();
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      orgName: "",
    },
    // validationSchema: validationSchema,
    validate: (values) => {
      const errors: { orgName?: string } = {};
      if (!values.orgName.trim()) {
        errors.orgName = "Organization name is required.";
      }
      return errors;
    },
    onSubmit: (values) => {
      handleSumitNewOrg(values);
    },
  });

  const handleSumitNewOrg = async (values) => {
    const newOrgData: CreateOrgSuperAdminData = {
      name: values.orgName,
      type: "CohortBased",
    };

    try {
      const response = await createOrg(newOrgData);
      if (response) {
        toast.success("Organization created successfully!");
        formik.resetForm();
        handleClose();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to create organization.");
    }
  };

  return (
    <Box>
     {isPending && <Box mb={1}> <Loader /> </Box>}
      <form onSubmit={formik.handleSubmit}>
        <TextField
          label="Organization Name"
          id="outlined-size-small"
          name="orgName"
          value={formik.values.orgName}
          onChange={formik.handleChange}
          size="small"
          error={formik.submitCount > 0 && Boolean(formik.errors.orgName)}
          helperText={formik.submitCount > 0 && formik.errors.orgName}
        />
        <Grid
          container
          sx={{
            justifyContent: "flex-end",
            mt: 2,
            gap: "8px",
          }}
        >
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            size="large"
            disabled={isPending}
            endIcon={isPending ? <CircularProgress size={16} /> : null}
          >
            Create
          </Button>
          {/* <Button variant="outlined" size="large" sx={buttonCommonStyle}>
            Create & Switch
          </Button> */}
        </Grid>
      </form>
    </Box>
  );
};

export default CreateOrgForm;
